const displayDate = (date: string) => {
  const dateObject = new Date(date);
  const yearMonthAndDay = dateObject.toLocaleString('pl-Pl', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
  return yearMonthAndDay;
};

export default displayDate;
